module.exports = __webpack_public_path__ + "img/about1-4.64372e66.png";